import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core"
import { Button } from "components"
import { StatusActions } from "types";

const SentToBankStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();

  return (
    <>
      <Box ml={'sm'}>
        <Button size={'compact-md'} color={'var(--mantine-color-grape-7)'} onClick={() => onClick('ACTIVE')} loading={isLoading}>
          {t('credit.status.action.ACTIVE')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => onClick('CANCELED_BANK')} loading={isLoading}>
          {t('credit.status.action.CANCELED_BANK')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => onClick('CANCELED_CLIENT')} loading={isLoading}>
          {t('credit.status.action.CANCELED_CLIENT')}
        </Button>
      </Box>
    </>
  )
}

export default SentToBankStatusActions;